angular.module('ihestiaWidgets.extraLife', [
  'ihestia-widgets-templates-app',
  'lsnBase.deepExtend',
  'ihestiaRestServicesBase',
  'lsnBase.utils'
]);